/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Submit_Transcription_JobInputs */



/**
* | output |
* | --- |
* | "Submit Job" |
*
* @param {Submit_Transcription_JobInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const submit_transcription_job = /** @type {((inputs?: Submit_Transcription_JobInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Submit_Transcription_JobInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Soumettre la tâche")
	if (locale === "de") return /** @type {LocalizedString} */ ("Job einreichen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Invia lavoro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отправить вакансию")
	if (locale === "es") return /** @type {LocalizedString} */ ("Enviar trabajo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("提交职位")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ジョブを送信")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नौकरी जमा करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Enviar vaga")
	return /** @type {LocalizedString} */ ("Submit Job")
});